import { ErnotsConfig, GetPageTitle } from "../../ErnotsConfig";
import { useAppSelector } from "../../store/hooks";
import { Anchor } from "../RequestRespectingInputs";
import { HomeExplanations } from "./explanation";

export function Home()
{
    const loggedInUserName = useAppSelector((state) => state.login.currentUser.username);
    const registerOrLogIn = 
    <span>      
        <Anchor to={`user/register`}>Register now</Anchor>, or, if you did that already, click <Anchor to={`loginform`}>here</Anchor> to log in.
    </span>

    const explanation = (
    <section>
        <p>
           <b>Welcome to {ErnotsConfig.AppName}!</b> {loggedInUserName ? <></> : registerOrLogIn}
        </p>
        
        {loggedInUserName ? HomeExplanations.instructions : <></>}
        {HomeExplanations.about}
    </section>);

    return (
    <>
        <title>{GetPageTitle('Home')}</title>
        <article className='ernots_SiteDescription'>{explanation}</article>
    </>);
}